export default __webpack_public_path__ + "static/media/logo-3d-ovato-coin-front-new.a2bd20e4.jpg";